export const ReportIndicatorTypePolicies = {
  ReportIndicator: {
    fields: {
      suggestButtonLabel: {
        read(_, { readField, toReference }) {
          const ri = toReference({ __typename: "ReportIndicator", id: readField("id") });
          const suggestion = readField("suggestion", ri);
          if (!suggestion) {
            return "Suggest";
          }
          const submittedAt = suggestion.submitted_at || readField("submitted_at", suggestion);
          if (submittedAt) {
            return "Suggestion submitted";
          }
          return "Edit Suggestion";
        }
      }
    }
  }
};
